/* TTP: zoekbalk binnen een collectie.
 * Markup: snippets/ttp-collectie-zoek.liquid (aan/uit via main-collection > "Zoekbalk binnen collectie").
 * Collecties tot INDEX_MAX_PRODUCTS producten (na filters) worden in de browser doorzocht via
 * /collections/<handle>?view=ttp-zoekindex (zelfde werking als "Zoek binnen selectie" op de modelpagina's).
 * Grotere collecties gebruiken Shopify-zoeken (/search?view=ttp-zoekindex) en houden alleen producten uit deze collectie over.
 * Kaarten komen uit /products/<handle>?section_id=ttp-zoek-kaart, dus identiek aan de collectiekaarten.
 * Zoekmodus (data-ttp-czoek-mode="search", zoekresultatenpagina): de index zijn de resultaten van de huidige
 * zoekopdracht via /search?<zelfde parameters>&view=ttp-zoekindex (Shopify geeft er max. 1000). */
(function () {
  'use strict';
  if (window.__ttpCollectieZoek) return;
  window.__ttpCollectieZoek = true;

  var INDEX_MAX_PRODUCTS = 13000;
  var INDEX_CONCURRENCY = 6;
  var SEARCH_PAGES = 4;
  var BATCH = 24;
  var MIN_LENGTH = 2;
  var DEBOUNCE_MS = 220;
  var CACHE_TTL = 15 * 60 * 1000;
  var STORAGE_KEY = 'ttp-czoek-index-v2';

  var indexes = {};
  var engineCache = {};
  var cardCache = {};
  var runId = 0;
  var timer = null;
  var current = null;
  var activeQuery = '';

  function root() {
    return document.querySelector('[data-ttp-czoek]');
  }

  function sectionOf(el) {
    return el && el.closest('.shopify-section');
  }

  function config(el) {
    return {
      id: el.getAttribute('data-collection-id') || '',
      handle: el.getAttribute('data-collection-handle') || '',
      url: el.getAttribute('data-collection-url') || window.location.pathname,
      title: el.getAttribute('data-collection-title') || '',
      mode: el.getAttribute('data-ttp-czoek-mode') || 'collection'
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Zoeklogica gelijk aan assets/tps-scooter-fitment-v29.js (modelpagina's). */
  function normalizeSearch(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function searchTokens(value) {
    var seen = {};
    return normalizeSearch(value)
      .split(/\s+/)
      .filter(function (token) {
        if (!token || seen[token]) return false;
        seen[token] = true;
        return true;
      });
  }

  function editDistanceAtMost(a, b, limit) {
    if (!a || !b) return false;
    if (Math.abs(a.length - b.length) > limit) return false;
    var prev = [];
    for (var j = 0; j <= b.length; j += 1) prev[j] = j;
    for (var i = 1; i <= a.length; i += 1) {
      var row = [i];
      var best = row[0];
      for (j = 1; j <= b.length; j += 1) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        row[j] = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + cost);
        if (row[j] < best) best = row[j];
      }
      if (best > limit) return false;
      prev = row;
    }
    return prev[b.length] <= limit;
  }

  function tokenMatchesWord(token, word) {
    if (!token || !word) return false;
    if (word.indexOf(token) >= 0) return true;
    if (token.length < 4 || word.length < 4) return false;
    return editDistanceAtMost(token, word, 1);
  }

  function prepared(text) {
    var normalized = normalizeSearch(text);
    return {
      text: normalized,
      compact: normalized.replace(/\s+/g, ''),
      words: normalized ? normalized.split(/\s+/) : []
    };
  }

  function fuzzyScore(prep, tokens) {
    if (!prep.text) return 0;
    var score = 0;
    for (var i = 0; i < tokens.length; i += 1) {
      var token = tokens[i];
      if (prep.text.indexOf(token) >= 0) {
        score += 12;
        continue;
      }
      if (prep.compact.indexOf(token) >= 0) {
        score += 10;
        continue;
      }
      var matched = false;
      for (var j = 0; j < prep.words.length; j += 1) {
        if (tokenMatchesWord(token, prep.words[j])) {
          matched = true;
          score += 5;
          break;
        }
      }
      if (!matched) return 0;
    }
    return score;
  }

  function productScore(item, tokens) {
    if (!item.prep) {
      item.prep = prepared([item.sku, item.barcode, item.title, item.vendor, item.type].join(' '));
      item.prepTitle = prepared(item.title);
      item.prepSku = prepared(item.sku);
    }
    var score = fuzzyScore(item.prep, tokens);
    if (!score) return 0;
    return score + fuzzyScore(item.prepSku, tokens) * 4 + fuzzyScore(item.prepTitle, tokens) * 2;
  }

  /* Huidige filters en sortering uit de URL, zodat de zoekbalk binnen de gefilterde selectie zoekt. */
  function viewParams(cfg) {
    var params = new URLSearchParams(window.location.search);
    var search = cfg && cfg.mode === 'search';
    var keep = [];
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by') keep.push([key, value]);
      else if (search && (key === 'q' || key === 'type' || key.indexOf('options') === 0)) keep.push([key, value]);
    });
    keep.sort(function (a, b) {
      return a[0] === b[0] ? (a[1] < b[1] ? -1 : 1) : a[0] < b[0] ? -1 : 1;
    });
    return keep;
  }

  function paramString(pairs) {
    return pairs
      .map(function (pair) {
        return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]);
      })
      .join('&');
  }

  function hasExplicitSort() {
    var sort = new URLSearchParams(window.location.search).get('sort_by');
    return Boolean(sort);
  }

  /* Geen Accept: application/json meesturen: dan geeft Shopify zijn eigen JSON i.p.v. de ttp-zoekindex-weergave. */
  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var data = JSON.parse(text);
        if (!data || !Array.isArray(data.items)) throw new Error('Onverwacht antwoord');
        data.items = data.items.filter(Boolean);
        return data;
      });
  }

  /* Rijen uit search.ttp-zoekindex: [handle, collectie-ids, titel, merk, type, sku's, barcodes, op voorraad]. */
  function searchItems(rows, page) {
    return rows.map(function (row, i) {
      return { handle: row[0], title: row[2], vendor: row[3], type: row[4], sku: row[5], barcode: row[6], available: row[7] === 1, index: page * 1000 + i };
    });
  }

  function collectionItems(rows, page) {
    return rows.map(function (row, i) {
      return { handle: row[0], title: row[1], vendor: row[2], type: row[3], sku: row[4], barcode: row[5], available: row[6] === 1, index: page * 1000 + i };
    });
  }

  function readStoredIndex(key) {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (stored && stored.key === key && Date.now() - stored.time < CACHE_TTL) return stored;
    } catch (error) {}
    return null;
  }

  function storeIndex(key, rows, count) {
    if (!rows.length) return;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ key: key, time: Date.now(), rows: rows, count: count }));
    } catch (error) {
      try {
        window.sessionStorage.removeItem(STORAGE_KEY);
      } catch (ignore) {}
    }
  }

  /* Laadt de collectie-index (alle producten van de collectie met actieve filters). */
  function loadIndex(cfg) {
    var pairs = viewParams(cfg);
    var searchMode = cfg.mode === 'search';
    var toItems = searchMode ? searchItems : collectionItems;
    var key = cfg.url + '?' + paramString(pairs);
    if (indexes[key]) return indexes[key];

    var state = { key: key, status: 'loading', mode: 'index', items: [], count: 0, loadedPages: 0, pages: 0, listeners: [] };
    indexes[key] = state;

    function notify() {
      state.listeners.slice().forEach(function (listener) {
        listener(state);
      });
    }

    var pageRows = [];
    var pageItems = [];

    function contiguousItems() {
      var items = [];
      for (var p = 1; p <= state.pages; p += 1) {
        if (!pageItems[p]) break;
        items = items.concat(pageItems[p]);
      }
      return items;
    }

    function finish() {
      var seen = {};
      state.items = contiguousItems().filter(function (item) {
        if (seen[item.handle]) return false;
        seen[item.handle] = true;
        return true;
      });
      state.status = 'ready';
      notify();
    }

    function addPage(page, rows) {
      pageRows[page] = rows;
      pageItems[page] = toItems(rows, page);
    }

    var stored = readStoredIndex(key);
    if (stored) {
      state.count = stored.count;
      state.loadedPages = state.pages = 1;
      addPage(1, stored.rows);
      finish();
      return state;
    }

    var base = searchMode
      ? '/search?view=ttp-zoekindex&' + paramString(pairs) + '&page='
      : cfg.url + '?view=ttp-zoekindex' + (pairs.length ? '&' + paramString(pairs) : '') + '&page=';

    fetchJson(base + '1')
      .then(function (first) {
        state.count = Number(searchMode ? first.total : first.count) || first.items.length;
        state.pages = Math.max(1, Number(first.pages) || 1);
        if (state.count > INDEX_MAX_PRODUCTS) {
          state.mode = 'engine';
          state.status = 'ready';
          notify();
          return;
        }
        addPage(1, first.items);
        state.loadedPages = 1;
        if (state.pages === 1) {
          storeIndex(key, first.items, state.count);
          finish();
          return;
        }
        state.items = contiguousItems();
        notify();

        var next = 2;
        function worker() {
          if (next > state.pages) return Promise.resolve();
          var page = next;
          next += 1;
          return fetchJson(base + page).then(function (data) {
            addPage(page, data.items);
            state.loadedPages += 1;
            if (state.loadedPages < state.pages) {
              var items = contiguousItems();
              if (items.length !== state.items.length) {
                state.items = items;
                notify();
              }
            }
            return worker();
          });
        }
        var workers = [];
        for (var w = 0; w < INDEX_CONCURRENCY; w += 1) workers.push(worker());
        return Promise.all(workers).then(function () {
          var rows = [];
          for (var p = 1; p <= state.pages; p += 1) rows = rows.concat(pageRows[p] || []);
          storeIndex(key, rows, state.count);
          finish();
        });
      })
      .catch(function () {
        state.mode = 'engine';
        state.status = 'ready';
        notify();
      });

    return state;
  }

  /* Grote collecties: Shopify-zoeken (max. 1000 resultaten) en alleen producten uit deze collectie houden. */
  function engineSearch(cfg, query) {
    var pairs = viewParams().filter(function (pair) {
      return pair[0].indexOf('filter.') === 0;
    });
    if (cfg.mode === 'search') {
      var original = new URLSearchParams(window.location.search).get('q') || '';
      query = (original + ' ' + query).trim();
    }
    var key = cfg.handle + '|' + paramString(pairs) + '|' + query;
    if (engineCache[key]) return engineCache[key];
    var base =
      '/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&view=ttp-zoekindex&q=' +
      encodeURIComponent(query) +
      (pairs.length ? '&' + paramString(pairs) : '') +
      '&page=';
    var pages = [];
    for (var p = 1; p <= SEARCH_PAGES; p += 1) {
      pages.push(
        fetchJson(base + p).catch(function () {
          return { items: [] };
        })
      );
    }
    var everything = cfg.handle === 'all' || !cfg.id;
    engineCache[key] = Promise.all(pages).then(function (results) {
      var seen = {};
      var items = [];
      results.forEach(function (data) {
        data.items.forEach(function (row) {
          if (seen[row[0]]) return;
          seen[row[0]] = true;
          if (!everything && String(row[1]).split(',').indexOf(cfg.id) < 0) return;
          items.push({ handle: row[0], title: row[2], vendor: row[3], type: row[4], sku: row[5], barcode: row[6], available: row[7] === 1, index: items.length });
        });
      });
      return items;
    });
    return engineCache[key];
  }

  function rankItems(items, tokens, keepOrder) {
    var rows = [];
    items.forEach(function (item) {
      var score = productScore(item, tokens);
      if (score) rows.push({ item: item, score: score });
    });
    rows.sort(function (a, b) {
      if (!keepOrder && a.item.available !== b.item.available) return a.item.available ? -1 : 1;
      if (!keepOrder && b.score !== a.score) return b.score - a.score;
      return a.item.index - b.item.index;
    });
    return rows.map(function (row) {
      return row.item;
    });
  }

  /* Kaarten ophalen via de Section Rendering API (zelfde snippet als de collectie). */
  function fetchCard(handle) {
    if (cardCache[handle]) return cardCache[handle];
    cardCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=ttp-zoek-kaart', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html;
        var li = template.content.querySelector('[data-ttp-zoek-kaart] > li');
        return li ? li.outerHTML : '';
      })
      .catch(function () {
        delete cardCache[handle];
        return '';
      });
    return cardCache[handle];
  }

  /* Zelfde herinitialisatie als "Toon meer producten" in assets/page-collection.js. */
  function refreshTheme() {
    ['ratings', 'semanticInput', 'schemeTooltip', 'popups', 'listScrollable', 'productVariants', 'formZindex', 'semanticSelect', 'check-limit-event'].forEach(function (type) {
      try {
        window.dispatchEvent(new CustomEvent(type));
      } catch (error) {}
    });
    try {
      if (window.ajaxCart && window.ajaxCart.init) window.ajaxCart.init();
    } catch (error) {}
    try {
      if (window.quickShop && window.quickShop.init) window.quickShop.init();
    } catch (error) {}
  }

  /* --- weergave --- */

  function pagingNodes(section, grid) {
    var nodes = [];
    var info = section.querySelector('#load-more-info');
    if (info) nodes.push(info);
    section.querySelectorAll('#load-more-button').forEach(function (button) {
      var holder = button.closest('p') || button;
      nodes.push(holder);
    });
    section.querySelectorAll('nav.n6pg').forEach(function (nav) {
      nodes.push(nav);
    });
    var sibling = grid.nextElementSibling;
    while (sibling) {
      if (sibling.tagName === 'HR') nodes.push(sibling);
      sibling = sibling.nextElementSibling;
    }
    return nodes;
  }

  /* Weergave zoals de modelpagina's: alleen het aantal verandert, onderaan "Je hebt X van de Y producten gezien". */
  function ensureView(el) {
    var section = sectionOf(el);
    var grid = section && section.querySelector('#collection');
    if (!section || !grid) return null;
    if (current && current.grid === grid) return current;
    if (current) leaveView(true);

    var status = document.createElement('p');
    status.className = 'ttp-czoek-sr';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    grid.parentNode.insertBefore(status, grid);

    var empty = document.createElement('p');
    empty.className = 'ttp-czoek-leeg';
    empty.hidden = true;
    grid.parentNode.insertBefore(empty, grid.nextSibling);

    var paging = document.createElement('div');
    paging.className = 'ttp-czoek-paging';
    paging.hidden = true;
    paging.innerHTML =
      '<hr class="m25">' +
      '<div class="text-center"><p>Je hebt <span class="strong" data-ttp-czoek-shown>0</span> van de <span class="strong" data-ttp-czoek-total>0</span> producten gezien</p>' +
      '<div><p class="s1br m20"><span class="rating-label"><span class="bar" data-ttp-czoek-bar style="width: 0%"></span></span></p></div></div>' +
      '<p class="link-btn text-center" data-ttp-czoek-more-wrap><a href="#" data-ttp-czoek-more>Toon meer producten</a></p>';
    empty.parentNode.insertBefore(paging, empty.nextSibling);

    var hidden = pagingNodes(section, grid);
    hidden.forEach(function (node) {
      node.classList.add('ttp-czoek-hidden');
    });

    var counter = section.querySelector('.f8sr .hx');
    current = {
      el: el,
      section: section,
      grid: grid,
      saved: null,
      renderedKey: '',
      status: status,
      empty: empty,
      paging: paging,
      hidden: hidden,
      counter: counter,
      counterText: counter ? counter.textContent : '',
      results: [],
      partial: false,
      shown: 0,
      query: ''
    };
    return current;
  }

  function leaveView(silent) {
    if (!current) return;
    var view = current;
    current = null;
    if (view.grid.isConnected) {
      if (view.saved) {
        view.grid.innerHTML = '';
        view.grid.appendChild(view.saved);
      }
      view.grid.classList.remove('processing');
    }
    view.hidden.forEach(function (node) {
      node.classList.remove('ttp-czoek-hidden');
    });
    [view.status, view.empty, view.paging].forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    if (view.counter) view.counter.textContent = view.counterText;
    if (!silent) refreshTheme();
  }

  function amountText(total, partial) {
    return String(total) + (partial ? '+' : '') + (total === 1 && !partial ? ' product' : ' producten');
  }

  function showLoading(view, state) {
    view.grid.classList.add('processing');
    if (!view.counter) return;
    if (state && state.mode === 'index' && state.pages > 1 && state.loadedPages < state.pages) {
      view.counter.textContent = 'Zoeken… ' + Math.round((state.loadedPages / state.pages) * 100) + '%';
    } else {
      view.counter.textContent = 'Zoeken…';
    }
  }

  function renderSummary(view, query, total, partial) {
    view.partial = partial;
    if (view.counter) view.counter.textContent = amountText(total, partial);
    view.status.textContent = amountText(total, partial) + ' gevonden voor ' + query;
    if (!total && !partial) {
      view.empty.innerHTML =
        'Geen artikelen gevonden binnen deze ' + (config(view.el).mode === 'search' ? 'resultaten' : 'selectie') + '. <a href="/search?type=product&amp;q=' +
        encodeURIComponent(query) +
        '">Zoek in de hele winkel</a>';
      view.empty.hidden = false;
    } else {
      view.empty.hidden = true;
    }
  }

  function updatePaging(view) {
    var total = view.results.length;
    var shown = Math.min(view.shown, total);
    view.paging.querySelector('[data-ttp-czoek-shown]').textContent = shown;
    view.paging.querySelector('[data-ttp-czoek-total]').textContent = total + (view.partial ? '+' : '');
    view.paging.querySelector('[data-ttp-czoek-bar]').style.width = (total ? (shown / total) * 100 : 0) + '%';
    view.paging.querySelector('[data-ttp-czoek-more-wrap]').hidden = shown >= total;
    view.paging.hidden = false;
  }

  function renderBatch(view, append) {
    var run = runId;
    var start = append ? view.shown : 0;
    var slice = view.results.slice(start, start + BATCH);
    var key = slice
      .map(function (item) {
        return item.handle;
      })
      .join('|');
    if (!append && key === view.renderedKey && view.saved) {
      view.grid.classList.remove('processing');
      updatePaging(view);
      return Promise.resolve();
    }
    if (!append) view.grid.classList.add('processing');
    return Promise.all(
      slice.map(function (item) {
        return fetchCard(item.handle);
      })
    ).then(function (cards) {
      if (run !== runId || current !== view) return;
      var html = cards.join('');
      if (!view.saved) {
        view.saved = document.createDocumentFragment();
        while (view.grid.firstChild) view.saved.appendChild(view.grid.firstChild);
      }
      if (append) {
        view.grid.insertAdjacentHTML('beforeend', html);
      } else {
        view.grid.innerHTML = html;
        view.renderedKey = key;
      }
      view.shown = start + slice.length;
      view.grid.classList.remove('processing');
      updatePaging(view);
      refreshTheme();
    });
  }

  function syncUrl(query) {
    try {
      var url = new URL(window.location.href);
      if (query) url.searchParams.set('zoek', query);
      else url.searchParams.delete('zoek');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  function runSearch(el, rawQuery) {
    var query = String(rawQuery || '').trim();
    var tokens = searchTokens(query);
    activeQuery = query;
    runId += 1;
    var run = runId;
    syncUrl(tokens.join('').length >= MIN_LENGTH ? query : '');

    if (tokens.join('').length < MIN_LENGTH) {
      leaveView(false);
      return;
    }

    var view = ensureView(el);
    if (!view) return;
    view.query = query;
    var cfg = config(el);
    var state = loadIndex(cfg);

    function fromIndex() {
      if (run !== runId) return;
      var partial = state.status !== 'ready';
      view.results = rankItems(state.items, tokens, hasExplicitSort());
      if (partial && view.results.length < BATCH) {
        showLoading(view, state);
        return;
      }
      renderSummary(view, query, view.results.length, partial);
      renderBatch(view, false);
    }

    function fromEngine() {
      showLoading(view, null);
      engineSearch(cfg, query).then(function (items) {
        if (run !== runId) return;
        view.results = rankItems(items, tokens, true);
        renderSummary(view, query, view.results.length, false);
        renderBatch(view, false);
      });
    }

    function onState() {
      if (run !== runId) {
        detach();
        return;
      }
      if (state.mode === 'engine') {
        detach();
        fromEngine();
        return;
      }
      if (state.status === 'ready') detach();
      fromIndex();
    }

    function detach() {
      var at = state.listeners.indexOf(onState);
      if (at >= 0) state.listeners.splice(at, 1);
    }

    if (state.status === 'ready') {
      if (state.mode === 'engine') fromEngine();
      else fromIndex();
      return;
    }
    showLoading(view, state);
    state.listeners.push(onState);
    if (state.items.length) fromIndex();
  }

  function syncClear(el) {
    var input = el.querySelector('[data-ttp-czoek-input]');
    var clear = el.querySelector('[data-ttp-czoek-clear-input]');
    if (input && clear) clear.hidden = !input.value;
  }

  /* --- events (gedelegeerd: de sectie wordt bij filteren opnieuw opgebouwd) --- */

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-ttp-czoek-input]');
    if (!input) return;
    var el = input.closest('[data-ttp-czoek]');
    syncClear(el);
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      runSearch(el, input.value);
    }, DEBOUNCE_MS);
  });

  document.addEventListener(
    'focusin',
    function (event) {
      var input = event.target.closest && event.target.closest('[data-ttp-czoek-input]');
      if (!input) return;
      loadIndex(config(input.closest('[data-ttp-czoek]')));
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var input = event.target.closest && event.target.closest('[data-ttp-czoek-input]');
    if (!input) return;
    var el = input.closest('[data-ttp-czoek]');
    if (event.key === 'Enter') {
      event.preventDefault();
      window.clearTimeout(timer);
      runSearch(el, input.value);
      if (window.matchMedia('(max-width: 999px)').matches) input.blur();
    } else if (event.key === 'Escape' && input.value) {
      event.preventDefault();
      input.value = '';
      syncClear(el);
      window.clearTimeout(timer);
      runSearch(el, '');
    }
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest && event.target.closest('[data-ttp-czoek-clear], [data-ttp-czoek-clear-input]');
    if (clear) {
      event.preventDefault();
      var el = root();
      if (!el) return;
      var input = el.querySelector('[data-ttp-czoek-input]');
      if (input) input.value = '';
      syncClear(el);
      window.clearTimeout(timer);
      runSearch(el, '');
      if (clear.hasAttribute('data-ttp-czoek-clear-input') && input) input.focus();
      return;
    }
    var more = event.target.closest && event.target.closest('[data-ttp-czoek-more]');
    if (more && current) {
      event.preventDefault();
      if (more.classList.contains('loading')) return;
      more.classList.add('loading');
      renderBatch(current, true).then(function () {
        more.classList.remove('loading');
      });
    }
  });

  /* Filters herladen de sectie via AJAX: zoekopdracht opnieuw toepassen op de nieuwe selectie. */
  function watch(el) {
    var section = sectionOf(el);
    if (!section || section.__ttpCzoekWatched || !window.MutationObserver) return;
    section.__ttpCzoekWatched = true;
    new MutationObserver(function () {
      window.setTimeout(function () {
        var fresh = root();
        if (!fresh) return;
        if (current && !current.grid.isConnected) current = null;
        var input = fresh.querySelector('[data-ttp-czoek-input]');
        if (activeQuery && input && !input.value) {
          input.value = activeQuery;
          syncClear(fresh);
          runSearch(fresh, activeQuery);
        }
      }, 0);
    }).observe(section, { childList: true });
  }

  function init() {
    var el = root();
    if (!el) return;
    watch(el);
    var query = new URLSearchParams(window.location.search).get('zoek');
    var input = el.querySelector('[data-ttp-czoek-input]');
    if (query && input) {
      input.value = query;
      syncClear(el);
      runSearch(el, query);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
